
import { StorageConstants } from "../data/Constants";
import Languages from "../data/Languages";
import ILanguage from "../interfaces/ILanguage";
import CryptoHelper from "./CryptoHelper";
import StringHelper from "./StringHelper";


const authTokenStorage = {
    _storageName: StorageConstants.authTokenStorageName,

    get: function () {
        const authToken = CryptoHelper.privateCrypto.decrypt(sessionStorage.getItem(this._storageName) ?? '')
        return authToken;
    },

    set: function (authToken: string) {
        const authTokenEncrypted = CryptoHelper.privateCrypto.encrypt(authToken);
        sessionStorage.setItem(this._storageName, authTokenEncrypted);
    },

    remove: function () {
        sessionStorage.removeItem(this._storageName);
    }
}


const enterpriseIdStorage = {
    _storageName: StorageConstants.enterpriseIdStorageName,

    get: function () {
        const enterpriseId = CryptoHelper.privateCrypto.decrypt(sessionStorage.getItem(this._storageName) ?? '')
        return +enterpriseId;
    },

    set: function (enterpriseId: number) {
        const enterpriseIdEncrypted = CryptoHelper.privateCrypto.encrypt(enterpriseId.toString());
        sessionStorage.setItem(this._storageName, enterpriseIdEncrypted);
    },

    remove: function () {
        sessionStorage.removeItem(this._storageName);
    }
}


const sessionIdStorage = {
    _storageName: StorageConstants.sessionIdStorageName,

    get: function () {
        const sessionId = CryptoHelper.privateCrypto.decrypt(sessionStorage.getItem(this._storageName) ?? '');
        return sessionId;
    },

    exists: function () {
        return !!sessionStorage.getItem(this._storageName);
    },

    create: function () {
        const randomText = StringHelper.RandomText(16, false, true, true, false);
        const sessionIdEncrypted = CryptoHelper.privateCrypto.encrypt(randomText);
        sessionStorage.setItem(this._storageName, sessionIdEncrypted);
    },

    remove: function () {
        return sessionStorage.removeItem(this._storageName);
    }
}


const languageStorage = {
    _storageName: StorageConstants.languageStorageName,
    _defaultValue: Languages[0],

    validate: function (languageValue: string | null | undefined) {
        return Languages.find(lang => lang.value === languageValue) ?? this._defaultValue;
    },

    get: function () {
        const languageValue = CryptoHelper.privateCrypto.decrypt(localStorage.getItem(this._storageName) ?? '');
        return this.validate(languageValue);
    },

    set: function (language: ILanguage) {
        language = this.validate(language.value);
        
        const languageValueEncrypted = CryptoHelper.privateCrypto.encrypt(language.value);
        localStorage.setItem(this._storageName, languageValueEncrypted);
    }
}


export {
    authTokenStorage,
    enterpriseIdStorage,
    sessionIdStorage,
    languageStorage
}